import { useEffect, useState } from 'react';
import '../../styles/dashboard.css';
import calender from '../../assets/images/small/date.svg';
import pilgrim from '../../assets/images/small/pilgrim.svg';
import city from '../../assets/images/small/City.svg';
import state from '../../assets/images/small/State.svg';
import api from '../../services/api';
import { useNavigate } from "react-router-dom";
import CustomSelect from '../CustomSelect';
import LeadGraphChart from './LeadGraphChart';

const formatDate = (date) => {
  return date.toISOString().split('T')[0];
};

const getToday = () => formatDate(new Date());

const getOneMonthBack = () => {
  const date = new Date();
  date.setMonth(date.getMonth() - 1);
  return formatDate(date);
};


const GraphFilterComponent = () => {

  // --------------------
  // FILTER STATES
  // --------------------
  
  const [pilgrimageType, setPilgrimageType] = useState("2"); // Umrah
const [categoryType, setCategoryType] = useState("month"); // Month
  const [loading, setLoading] = useState(false);
const [graphData, setGraphData]= useState([])
  

  // --------------------
  // API CALL
  // --------------------


  const fetchGraphDetails = async () => {
        setLoading(true);

        try {
        const formData = new FormData();
        if(categoryType === "month"){
            formData.append('month', categoryType);
        }

        if(categoryType === "year"){
            formData.append('year', categoryType);
        }

        if(categoryType === "date"){
            formData.append('date', categoryType);
        }
        formData.append('category_id', pilgrimageType);

        const response = await api.post('/api/Dashboard/leadGraph', formData)
        const result =  response.data;

        if (result.status) {
            setGraphData(result.data);
        } else {
            setGraphData([]);
        }
        } catch (error) {
        console.error('API Error:', error);
        setGraphData([]);
        } finally {
        setLoading(false);
        }
    };

  const handleApplyFilters = (e) => {
    e.preventDefault();
    fetchGraphDetails(pilgrimageType,categoryType)
  }

  useEffect(() => {
  fetchGraphDetails();
}, [pilgrimageType, categoryType]);

  

  const pilgrimageOptions = [
    { id: "2", name: "Umrah" },
    { id: "1", name: "Hajj" },
  ];

  const categoryOptions = [
    { id: "month", name: "Month" },
    { id: "year", name: "Year" },
    { id: "date", name: "Date" },
  ];


  return (
    <div className="dashboard-content graph-filter-content">

      {/* FILTERS */}
      <div className="filter-containers">

      {/* <div >
        <h2 style={{fontSize: '26px', fontWeight: '700', marginBottom: '15px'}}>Lead Dashbord</h2>
      </div> */}
        
        <form onSubmit={handleApplyFilters}>

          {/* State (API later) */}
          <div className="filter-form-container">
            <div className="label-container">
              <div className="image-container">
                <img src={pilgrim} alt="state" />
              </div>
              <p>Pilgrim Type</p>
            </div>
            <CustomSelect
              options={pilgrimageOptions}
              value={pilgrimageType}
              onChange={(val) => setPilgrimageType(val)}
              labelKey="name"
              valueKey="id"
              placeholder="Select Pilgrim Type"
            />


          </div>

          {/* City (API later) */}
          <div className="filter-form-container">
            <div className="label-container">
              <div className="image-container">
                <img src={calender} alt="state" />
              </div>
              <p>Category</p>
            </div>
            <CustomSelect
              options={categoryOptions}
              value={categoryType}
              onChange={(val) => setCategoryType(val)}
              labelKey="name"
              valueKey="id"
              placeholder={"Select Category"}
            />


          </div>

          {/* Apply */}

        </form>


        <div style={{ marginTop: "20px" }}>
            {loading ? (
                <p>Loading chart...</p>
            ) : graphData.length > 0 ? (
                <LeadGraphChart data={graphData} />
            ) : (
                <p>No data available</p>
            )}
        </div>

      </div>


     
    </div>
  );
};

export default GraphFilterComponent;
